import React, { useEffect, useState } from 'react';
import s from './styles.module.scss';

const InAppBrowserDetector = ({ children }) => {
  const [isProblematicBrowser, setIsProblematicBrowser] = useState(false);
  const [browserType, setBrowserType] = useState('');

  useEffect(() => {
    const userAgent = (navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();
    
    const isSnapchat = userAgent.includes('snapchat') || userAgent.includes('snap');
    
    const isLinkedIn = userAgent.includes('linkedin') || 
                       userAgent.includes('linkedinapp');
    
    if (isSnapchat) {
      setIsProblematicBrowser(true);
      setBrowserType('Snapchat');
    } else if (isLinkedIn) {
      setIsProblematicBrowser(true);
      setBrowserType('LinkedIn');
    }
  }, []);

  const handleOpenInBrowser = () => {
    const currentUrl = window.location.href;
    
    // Use the same approach for both Snapchat and LinkedIn
    window.location.href = `googlechrome://${currentUrl.replace(/^https?:\/\//, '')}`;
    
    setTimeout(() => {
      window.location.href = currentUrl;
    }, 500);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      const button = document.getElementById('copy-button');
      if (button) {
        button.textContent = 'Copied!';
        setTimeout(() => {
          button.textContent = 'Copy Link';
        }, 2000);
      }
    });
  };

  if (isProblematicBrowser) {
    return (
      <div className={s.browserWarning}>
        <div className={s.warningCard}>
          <div className={s.iconContainer}>
            <svg className={s.warningIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          
          <h2 className={s.title}>Open in Your Browser</h2>
          
          <p className={s.message}>
            Google Sign-In works best in your phone's default browser. 
            The {browserType} browser may have issues with authentication.
          </p>

          <div className={s.buttonContainer}>
            <button 
              className={s.primaryButton}
              onClick={handleOpenInBrowser}
            >
              Open in Google Chrome App
            </button>
            
            <button 
              id="copy-button"
              className={s.secondaryButton}
              onClick={handleCopyLink}
            >
              Copy Link
            </button>
          </div>

          <div className={s.instructions}>
            <p className={s.instructionText}>
              <strong>If you do not have the Google Chrome App:</strong>
            </p>
            <ol className={s.instructionList}>
              <li>Tap the menu (⋮) or share button</li>
              <li>Select "Open in Browser" or similar option</li>
              <li>Or copy the link above and paste in your browser</li>
            </ol>
          </div>

          <button 
            className={s.skipButton}
            onClick={() => setIsProblematicBrowser(false)}
          >
            Continue anyway (not recommended)
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default InAppBrowserDetector;